import { useState } from 'react'
import { useIntl } from 'react-intl'
import { CircularProgress, Tab, Tabs } from 'react-md'
//import useSupplier from './useSupplier'
import {
	additionalInformationFormHeaders,
	supplierFormHeaders,
} from './constants'
import ViiluFullPageDialog from 'ui/components/ViiluFullPageDialog'
import { CreateFormGrid } from 'ui/ManagerFinance/components'
import SupplierFormInput from './SupplierFormInput'
import { FormProvider, useForm } from 'react-hook-form'
import { useZodValidationResolver } from 'util/hooks/useZodValidationResolver'
import { SupplierFormSchema } from './validation'
import type { SupplierFormInputs } from './validation'

type Props = {
	id?: string | null
	refresh: () => void
	onHide: () => void
}

const SupplierDialog = ({
	id,
	//refresh,
	onHide,
}: Props) => {
	const intl = useIntl()

	const [tabIndex, setTabIndex] = useState(0)
	//const { supplier } = useSupplier(id) //TODO: Update data with this

	const resolver =
		useZodValidationResolver<SupplierFormInputs>(SupplierFormSchema)

	const formMethods = useForm<SupplierFormInputs>({
		resolver,
		defaultValues: {},
		mode: 'onBlur',
		shouldUnregister: false,
	})

	const [processing, setProcessing] = useState(false)

	const onProcess = async () => {
		setProcessing(true)
		setProcessing(false)
	}

	const renderBasicInformation = () => {
		const rows = Math.ceil(supplierFormHeaders.length / 2)

		return (
			<CreateFormGrid
				style={{
					gridAutoFlow: 'column',
					gridTemplateRows: `repeat(${rows}, auto)`,
				}}
			>
				{supplierFormHeaders.map((input, index) => (
					<SupplierFormInput
						key={`${input.key as string}-${index}`} //TODO: REMOVE AS STRING
						input={input}
					/>
				))}
			</CreateFormGrid>
		)
	}

	const renderAdditionalInformation = () => {
		const rows = Math.ceil(additionalInformationFormHeaders.length / 2)

		return (
			<CreateFormGrid
				style={{
					gridAutoFlow: 'column',
					gridTemplateRows: `repeat(${rows}, auto)`,
				}}
			>
				{additionalInformationFormHeaders.map((input, index) => (
					<SupplierFormInput
						key={`${input.key as string}-${index}`} //TODO: REMOVE AS STRING
						input={input}
					/>
				))}
			</CreateFormGrid>
		)
	}

	const renderTabs = () => {
		return (
			<Tabs
				tabId="users-mobile-tab"
				mobile
				style={{
					flexShrink: 0,
					borderBottomStyle: 'solid',
					borderBottomColor: 'rgba(0,0,0,0.2)',
					borderBottomWidth: 1,
					marginBottom: '1rem',
				}}
				alignToKeyline={false}
				defaultTabIndex={tabIndex}
				activeTabIndex={tabIndex}
				onTabChange={() => {}}
				indicatorHeight={3}
			>
				<Tab
					key={0}
					style={
						tabIndex === 0
							? {
									color: 'var(--color-primary-dark)',
									fontWeight: '700',
									minWidth: '50%',
							  }
							: {
									color: 'var(--color-text-subtle)',
									minWidth: '50%',
							  }
					}
					label={intl.formatMessage({
						defaultMessage: '1. Perustiedot',
						description: '1. Basic information',
					})}
					onClick={() => setTabIndex(0)}
				/>
				<Tab
					key={1}
					style={
						tabIndex === 1
							? {
									color: 'var(--color-primary-dark)',
									fontWeight: '700',
									minWidth: '50%',
							  }
							: {
									color: 'var(--color-text-subtle)',
									minWidth: '50%',
							  }
					}
					label={intl.formatMessage({
						defaultMessage: '2. Lisätiedot',
						description: '2. Additional information',
					})}
					onClick={() => setTabIndex(1)}
				/>
			</Tabs>
		)
	}

	const renderChildren = () => {
		return (
			<div
				className="margin-left--lg margin-right--lg"
				style={{ paddingBottom: 64 }}
			>
				{renderTabs()}
				<FormProvider {...formMethods}>
					{tabIndex === 0 && renderBasicInformation()}
					{tabIndex === 1 && renderAdditionalInformation()}
				</FormProvider>
			</div>
		)
	}

	const actions = [
		{
			id: 'dialog-cancel',
			children: intl.formatMessage({
				defaultMessage: 'Peruuta',
				description: 'Cancel button',
			}),
			onClick: onHide,
		},
		{
			id: 'dialog-ok',
			secondary: true,
			children: processing ? (
				<CircularProgress id="progress" style={{ marginTop: 0 }} />
			) : (
				intl.formatMessage({
					defaultMessage: 'Tallenna',
					description: 'Save button',
				})
			),
			onClick: onProcess,
		},
	]

	return (
		<ViiluFullPageDialog
			id="supplier-dialog"
			visible
			title={
				id
					? intl.formatMessage({
							defaultMessage: 'Muokkaa toimittajaa',
							description: 'Title of edit supplier',
					  })
					: intl.formatMessage({
							defaultMessage: 'Lisää toimittaja',
							description: 'Title of add supplier',
					  })
			}
			toolbarStyle={{
				background: 'var(--color-primary-dark)',
				boxShadow: 'none',
			}}
			actions={actions}
			onHide={onHide}
		>
			{renderChildren()}
		</ViiluFullPageDialog>
	)
}

export default SupplierDialog
